import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const tabStyle = {
  border: "2px solid #0099ff",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "90%",
  margin: "30px auto 0 auto",
  background: "#fff",
  overflow: "hidden",
};

const tabButtonStyle = (isActive) => ({
  flex: 1,
  padding: "12px 0",
  background: isActive ? "#e6f4ff" : "transparent",
  border: "none",
  outline: "none",
  fontWeight: "bold",
  color: "#222",
  cursor: "pointer",
  fontSize: "1rem",
  transition: "background 0.2s",
  textDecoration: "none",
  textAlign: "center",
});

function Admin() {
  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>
      <div
        style={{
          background: "#fff",
          margin: "20px 0",
          padding: "30px 0 0 0",
          borderRadius: "8px",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: 40 }}
        >
          <span style={{ fontWeight: 700, fontSize: "1.5rem" }}>
            Admin - CriticalRiver Learning & Development
          </span>
        </div>

        {/* Navigation Tabs */}
        <div style={tabStyle}>
          <NavLink
            to="dashboard"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="courses"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            Courses
          </NavLink>
          <NavLink
            to="scorm"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            SCORM
          </NavLink>
          <NavLink
            to="tests"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            Tests
          </NavLink>
          <NavLink
            to="roles"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            Roles
          </NavLink>
          <NavLink
            to="approve-certifications"
            style={({ isActive }) => tabButtonStyle(isActive)}
          >
            Approve Certifications
          </NavLink>
        </div>

        {/* Render active tab's content */}
        <div style={{ margin: "30px 40px" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Admin;
